export default __webpack_public_path__ + "static/spatter-144b51156104a06f2be53459467c90e7.png";